/* Northpix Explore-grid: hover-preview, daglig blandning, visa fler, facetter. */
(function () {
  'use strict';

  var root = document.querySelector('[data-npx-explore]');
  if (!root) return;

  var MAX_PLAYING = parseInt(root.getAttribute('data-npx-max-playing'), 10) || 2;
  var MOBILE_AUTOPLAY = root.getAttribute('data-npx-mobile-autoplay') === 'true';
  var HOVER_DELAY = 140;
  var coarse = window.matchMedia('(hover: none)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  var FULL_KEY = 'northpix-explore-full';
  var fullMode = false;
  try { fullMode = localStorage.getItem(FULL_KEY) === '1'; } catch (e) {}

  // I fullbredd fyller ett klipp hela fonstret. Da ar hover meningslos —
  // previewen ska folja scrollen i stallet, ett klipp i taget.
  function autoMode() { return fullMode || (coarse && MOBILE_AUTOPLAY); }
  function hoverOn() { return !coarse && !fullMode; }


  /* ---------- Fröad blandning ---------- */

  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  // Frot kommer fran servern sa att alla besokare far samma ordning samma dygn,
  // oberoende av klientens tidszon.
  function daySeed() {
    var s = parseInt(root.getAttribute('data-npx-seed'), 10);
    if (s) return s;
    var d = new Date();
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  // Blandar bara de kort som redan finns i DOM. Varje laddad sida blandas for
  // sig, sa paginering ger aldrig dubbletter eller bortfall.
  function shuffleBatch(container, nodes, saltIndex) {
    if (!nodes.length) return;
    var rnd = mulberry32(daySeed() + saltIndex * 7919);
    var arr = nodes.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    var frag = document.createDocumentFragment();
    arr.forEach(function (n) { frag.appendChild(n); });
    container.appendChild(frag);
  }

  var batchIndex = 0;
  var grid = root.querySelector('[data-npx-grid]');

  /* ---------- Packning: kortaste kolumnen forst ---------- */

  // Master-ordningen. Packningen laser harifran, sa en ompackning vid
  // storleksandring aldrig andrar ordningen.
  var order = grid ? Array.prototype.slice.call(grid.children) : [];

  function ratioOf(tile) {
    var r = parseFloat(tile.getAttribute('data-npx-ratio'));
    return r > 0 ? r : 1.5;
  }

  var MAX_COLS = parseInt(root.getAttribute('data-npx-max-cols'), 10) || 6;
  var STORE_KEY = 'northpix-explore-cols';
  var userCols = null;

  try {
    // Gamla sparade varden kan ligga utanfor skalan (t.ex. 1 fran gamla
    // fullbreddsknappen). Allt ogiltigt ignoreras och standarden galler.
    var stored = parseInt(localStorage.getItem(STORE_KEY), 10);
    if (stored >= 2 && stored <= MAX_COLS) userCols = stored;
  } catch (e) {}

  // Grundvardet kommer fran temats brytpunkter. Besokarens val ligger ovanpa,
  // men klams alltid till vad skarmen taler sa 6 kolumner inte foljer med ner
  // till en telefon.
  function baseCols() {
    if (!grid) return 1;
    var v = parseInt(getComputedStyle(grid).getPropertyValue('--npx-cols-base'), 10);
    return v > 0 ? v : 1;
  }

  function maxForViewport() {
    var w = window.innerWidth || 1200;
    if (w < 750) return 3;
    if (w < 1200) return Math.min(MAX_COLS, 5);
    return MAX_COLS;
  }

  function colCount() {
    if (!grid) return 1;
    if (userCols) return Math.min(Math.max(userCols, 1), maxForViewport());
    return baseCols();
  }

  var cols = [];
  var heights = [];
  var packedAt = 0;

  function shortest() {
    var k = 0;
    for (var i = 1; i < heights.length; i++) if (heights[i] < heights[k]) k = i;
    return k;
  }

  // Hojd raknas i enheter av kolumnbredden: en 16:9-ruta ar 0.5625 enheter hog.
  function place(tile) {
    var k = shortest();
    cols[k].appendChild(tile);
    heights[k] += 1 / ratioOf(tile) + 0.01;
    var im = tile.querySelector('.npx-card__img[srcset]');
    if (im && packedAt) im.sizes = Math.ceil(100 / packedAt) + 'vw';
  }

  function pack() {
    var n = colCount();
    cols = [];
    heights = [];
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var c = document.createElement('div');
      c.className = 'npx-col';
      cols.push(c);
      heights.push(0);
      frag.appendChild(c);
    }
    grid.textContent = '';
    grid.appendChild(frag);
    grid.classList.add('is-packed');
    grid.style.setProperty('--npx-cols-now', n);
    order.forEach(place);
    packedAt = n;
    applySizes(n);
    syncDensity();
  }

  // srcset valjs efter hur bred en kolumn faktiskt ar.
  function applySizes(n) {
    var val = Math.ceil(100 / n) + 'vw';
    var imgs = grid.querySelectorAll('.npx-card__img[srcset]');
    for (var i = 0; i < imgs.length; i++) imgs[i].sizes = val;
  }

  /* ---------- Storlekskontroll: ikon + minus/plus + stegad slider ----------
     Skalan gar i storleksNIVAER, vanster = minst (flest kolumner), hoger =
     storst. Niva 1..MAX_COLS-1 ger MAX_COLS+1-niva kolumner (t.ex. MAX_COLS=6:
     1→6, 2→5, 3→4, 4→3, 5→2). Hogsta nivan (MAX_COLS) ar fullbredd:
     npx-explore--full, ett klipp per rad kant i kant. */

  var density = root.querySelector('[data-npx-density]');
  var sizeSlider = density ? density.querySelector('[data-npx-size]') : null;

  // Lagsta valbara nivan just nu: skarmen begransar hur manga kolumner som
  // far plats (maxForViewport), sa pa en telefon borjar skalan hogre upp.
  function levelMin() {
    var lm = MAX_COLS + 1 - maxForViewport();
    return Math.min(Math.max(lm, 1), MAX_COLS - 1);
  }

  function currentLevel() {
    if (fullMode) return MAX_COLS;
    var lv = MAX_COLS + 1 - colCount();
    return Math.min(Math.max(lv, 1), MAX_COLS - 1);
  }

  function syncDensity() {
    if (!density) return;
    density.hidden = false;
    var lv = currentLevel();
    if (sizeSlider) {
      sizeSlider.min = '1';
      sizeSlider.max = String(MAX_COLS);
      sizeSlider.value = String(lv);
    }
    var minus = density.querySelector('[data-npx-size-step="-1"]');
    var plus = density.querySelector('[data-npx-size-step="1"]');
    if (minus) minus.disabled = lv <= levelMin();
    if (plus) plus.disabled = lv >= MAX_COLS;
  }

  function setLevel(lv) {
    lv = parseInt(lv, 10);
    if (!(lv >= 1)) { syncDensity(); return; }
    lv = Math.min(Math.max(lv, 1), MAX_COLS);
    if (lv === currentLevel()) { syncDensity(); return; }
    if (lv >= MAX_COLS) {
      // Hogsta nivan = fullbredd. userCols satts till 1 precis som gamla
      // fullbreddsknappen gjorde, men skrivs inte till STORE_KEY, sa det
      // senaste kolumnvalet finns kvar nar besokaren lamnar fullbredd.
      fullMode = true;
      userCols = 1;
      applyFull();
      pack();
      return;
    }
    if (fullMode) { fullMode = false; applyFull(); }
    userCols = Math.min(Math.max(MAX_COLS + 1 - lv, 2), maxForViewport());
    try { localStorage.setItem(STORE_KEY, String(userCols)); } catch (err) {}
    pack();
  }

  function setVw() {
    var w = document.documentElement.clientWidth;
    // Skydd: en icke-renderande vy rapporterar 0, och 0px hade kollapsat
    // rutnatet. Da faller CSS tillbaka pa 100vw i stallet.
    if (w > 0) root.style.setProperty('--npx-vw', w + 'px');
    else root.style.removeProperty('--npx-vw');
  }

  function applyFull() {
    setVw();
    root.classList.toggle('npx-explore--full', fullMode);
    try { localStorage.setItem(FULL_KEY, fullMode ? '1' : '0'); } catch (e) {}
    MAX_PLAYING = fullMode ? 1 : (parseInt(root.getAttribute('data-npx-max-playing'), 10) || 2);
    if (autoMode()) ensureIO(); else teardownIO();
  }

  if (density) {
    // − ar mindre miniatyrer (fler kolumner, lagre niva), + ar storre
    // (farre kolumner, hogre niva). Hogsta nivan slar over i fullbredd.
    density.addEventListener('click', function (e) {
      var b = e.target.closest('[data-npx-size-step]');
      if (!b || b.disabled) return;
      setLevel(currentLevel() + parseInt(b.getAttribute('data-npx-size-step'), 10));
    });
  }

  if (sizeSlider) {
    var onSlide = function () { setLevel(sizeSlider.value); };
    sizeSlider.addEventListener('input', onSlide);
    sizeSlider.addEventListener('change', onSlide);
  }

  if (fullMode) userCols = 1;
  applyFull();

  if (grid) {
    if (grid.getAttribute('data-npx-shuffle') === 'daily') {
      shuffleBatch(grid, order, batchIndex++);
      order = Array.prototype.slice.call(grid.children);
    }
    pack();

    var rzTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(rzTimer);
      rzTimer = setTimeout(function () {
        setVw();
      if (colCount() !== packedAt) pack(); else syncDensity();
      }, 180);
    });
  }

  /* ---------- Hover-preview ---------- */

  var playing = [];

  function stop(card) {
    var v = card.__npxVideo;
    card.classList.remove('is-playing');
    if (v) { try { v.pause(); } catch (e) {} }
    var i = playing.indexOf(card);
    if (i > -1) playing.splice(i, 1);
  }

  function trim() {
    while (playing.length > MAX_PLAYING) stop(playing[0]);
  }

  // Med oandlig scroll kan tusentals kort ligga i DOM. Videoelement skapas bara
  // vid hover, men de maste ocksa stadas bort igen annars vaxer minnet.
  var VIDEO_CACHE = 12;
  var made = [];

  function destroy(card) {
    var v = card.__npxVideo;
    if (!v) return;
    stop(card);
    v.removeAttribute('src');
    try { v.load(); } catch (e) {}
    if (v.parentNode) v.parentNode.removeChild(v);
    card.__npxVideo = null;
  }

  function start(card) {
    var src = card.getAttribute('data-npx-preview');
    if (!src || saveData) return;
    var v = card.__npxVideo;
    if (!v) {
      v = document.createElement('video');
      v.className = 'npx-card__video';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'none');
      v.setAttribute('disableremoteplayback', '');
      v.setAttribute('tabindex', '-1');
      v.setAttribute('aria-hidden', 'true');
      v.src = src;
      card.appendChild(v);
      card.__npxVideo = v;
      v.addEventListener('error', function () {
        card.removeAttribute('data-npx-preview');
        stop(card);
      });
      made.push(card);
      while (made.length > VIDEO_CACHE) {
        var old = made.shift();
        if (old !== card && playing.indexOf(old) === -1) destroy(old);
      }
    }
    if (playing.indexOf(card) === -1) playing.push(card);
    trim();
    var p = v.play();
    if (p && p.catch) p.catch(function () { stop(card); });
    card.classList.add('is-playing');
  }

  var hoverTimer = null;
  var hoverCard = null;

  function onOver(e) {
    if (!hoverOn()) return;
    var card = e.target.closest ? e.target.closest('.npx-card[data-npx-preview]') : null;
    if (!card || card === hoverCard) return;
    if (hoverCard) stop(hoverCard);
    hoverCard = card;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      if (hoverCard === card) start(card);
    }, HOVER_DELAY);
  }

  function onOut(e) {
    if (!hoverOn()) return;
    var card = e.target.closest ? e.target.closest('.npx-card') : null;
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    clearTimeout(hoverTimer);
    if (hoverCard === card) hoverCard = null;
    stop(card);
  }

  root.addEventListener('mouseover', onOver, true);
  root.addEventListener('mouseout', onOut, true);
  window.addEventListener('pagehide', function () {
    playing.slice().forEach(stop);
  });

  /* ---------- Spela det mest synliga kortet, ett i taget ---------- */

  var io = null;
  var visible = new Map();

  function ioCallback(entries) {
    entries.forEach(function (en) {
      if (en.intersectionRatio > 0.55) visible.set(en.target, en.intersectionRatio);
      else visible.delete(en.target);
    });
    if (!autoMode()) return;
    var best = null, bestR = 0;
    visible.forEach(function (r, el) { if (r > bestR) { bestR = r; best = el; } });
    playing.slice().forEach(function (c) { if (c !== best) stop(c); });
    if (best) start(best);
  }

  function ensureIO() {
    if (io || saveData || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(ioCallback, { threshold: [0, 0.55, 0.9] });
    observe(root);
  }

  function teardownIO() {
    if (!io) return;
    io.disconnect();
    io = null;
    visible.clear();
    playing.slice().forEach(stop);
  }

  function observe(scope) {
    if (!io) return;
    var list = scope.querySelectorAll('.npx-card[data-npx-preview]');
    for (var i = 0; i < list.length; i++) io.observe(list[i]);
  }

  if (autoMode()) ensureIO();

  /* ---------- Facetter ---------- */

  var form = root.querySelector('[data-npx-facets]');
  var panel = root.querySelector('[data-npx-facets-panel]');
  var toggle = root.querySelector('[data-npx-filters-toggle]');

  if (toggle && panel) {
    var anyActive = !!panel.querySelector('.npx-chip.is-active');
    if (anyActive) { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  if (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-npx-sort]')) { form.submit(); return; }
      if (t.type === 'checkbox') {
        t.closest('.npx-chip').classList.toggle('is-active', t.checked);
        form.submit();
      }
    });
    // Tomma falt ska inte hamna i URL:en.
    form.addEventListener('submit', function () {
      Array.prototype.forEach.call(form.elements, function (el) {
        if ((el.type === 'search' || el.tagName === 'SELECT') && el.value === '') el.disabled = true;
      });
    });
  }

  /* ---------- Sticky verktygsrad + flytande facettpanel ----------
     En sentinel precis fore raden observeras: nar den lamnar rutan uppat ar
     raden fastnad (npx-bar--stuck). I fastnat lage stangs flodespanelen (utan
     att rora localStorage — auto-stangning ar inte ett anvandarval) och
     Filter-knappen oppnar i stallet panelen som overlay (npx-facets--overlay,
     samma DOM-element). Nar raden slapper aterstalls flodeslaget. */

  var bar = root.querySelector('.npx-bar');
  var barSentinel = root.querySelector('[data-npx-bar-sentinel]');
  var barStuck = false;
  // Panelens oppen/stangd-lage i flodet, sa det kan aterstallas nar raden
  // slapper. Overlay-oppningar ar efemara och paverkar inte detta.
  var flowOpen = panel ? !panel.hidden : false;

  function setBarStuck(on) {
    if (!bar || on === barStuck) return;
    barStuck = on;
    bar.classList.toggle('npx-bar--stuck', on);
    if (panel) panel.classList.toggle('npx-facets--overlay', on);
    if (!panel || !toggle) return;
    if (on) {
      flowOpen = !panel.hidden;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      panel.hidden = !flowOpen;
      toggle.setAttribute('aria-expanded', String(flowOpen));
    }
  }

  function closeOverlay() {
    if (!barStuck || !panel || panel.hidden) return;
    panel.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (bar && barSentinel && 'IntersectionObserver' in window) {
    // rootMargin foljer radens top-varde (--npx-bar-top), sa detekteringen
    // stammer aven om raden ska fastna under ett sticky sidhuvud.
    var barTop = parseFloat(getComputedStyle(bar).top) || 0;
    var stickIO = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      setBarStuck(!en.isIntersecting);
    }, { rootMargin: (-Math.round(barTop)) + 'px 0px 0px 0px', threshold: 0 });
    stickIO.observe(barSentinel);

    document.addEventListener('click', function (e) {
      if (!barStuck || !panel || panel.hidden) return;
      if (bar.contains(e.target)) return;
      closeOverlay();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!barStuck || !panel || panel.hidden) return;
      closeOverlay();
      if (toggle) toggle.focus();
    });
  }

  /* ---------- Visa fler / oandlig scroll ---------- */

  var moreWrap = root.querySelector('.npx-more');
  var moreBtn = root.querySelector('[data-npx-more]');
  var INFINITE = root.getAttribute('data-npx-infinite') === 'true';
  var AUTO_PAGES = parseInt(root.getAttribute('data-npx-auto-pages'), 10) || 0;
  var autoLeft = INFINITE ? AUTO_PAGES : 0;
  var loading = false;
  var sentinelIO = null;

  function finishInfinite() {
    autoLeft = 0;
    if (sentinelIO) { sentinelIO.disconnect(); sentinelIO = null; }
    if (moreWrap) moreWrap.classList.remove('npx-more--auto');
  }

  function loadNext() {
    if (!moreBtn || loading) return Promise.resolve(false);
    var url = moreBtn.getAttribute('data-npx-next');
    if (!url) return Promise.resolve(false);
    loading = true;
    moreBtn.disabled = true;
    var label = moreBtn.getAttribute('data-npx-label') || moreBtn.textContent;
    moreBtn.setAttribute('data-npx-label', label);
    moreBtn.textContent = '\u2026';

    return fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-npx-grid]');
        var nextBtn = doc.querySelector('[data-npx-more]');

        if (nextGrid && grid) {
          var nodes = Array.prototype.slice.call(nextGrid.children);
          if (grid.getAttribute('data-npx-shuffle') === 'daily') {
            var tmp = document.createElement('div');
            shuffleBatch(tmp, nodes, batchIndex++);
            nodes = Array.prototype.slice.call(tmp.children);
          }
          nodes.forEach(function (t) { order.push(t); place(t); });
          observe(grid);
        }

        loading = false;
        if (nextBtn && nextBtn.getAttribute('data-npx-next')) {
          moreBtn.setAttribute('data-npx-next', nextBtn.getAttribute('data-npx-next'));
          moreBtn.disabled = false;
          moreBtn.textContent = label;
          return true;
        }
        finishInfinite();
        if (moreWrap) moreWrap.remove();
        moreBtn = null;
        return false;
      })
      .catch(function () {
        loading = false;
        // Nataverksfel: sluta ladda automatiskt och lamna kvar knappen sa
        // besokaren kan forsoka sjalv i stallet for att fastna i en tyst loop.
        finishInfinite();
        if (moreBtn) {
          moreBtn.disabled = false;
          moreBtn.textContent = moreBtn.getAttribute('data-npx-label') || 'Visa fler';
        }
        return false;
      });
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () { loadNext(); });
  }

  if (INFINITE && moreWrap && moreBtn && autoLeft > 0 && 'IntersectionObserver' in window) {
    moreWrap.classList.add('npx-more--auto');
    sentinelIO = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      if (loading || autoLeft <= 0) return;
      autoLeft--;
      loadNext().then(function (more) {
        if (!more || autoLeft <= 0) finishInfinite();
      });
    }, { rootMargin: '800px 0px' });
    sentinelIO.observe(moreWrap);
  }
})();
